import * as types from "./actionTypes";
import * as eventTypes from "./eventTypes";
import initialState from "reducers/initialState";

export default function eligibilityReducer(state = initialState.currentOffer.partnerEligibilityData, action) {
  switch (action.type) {
    case types.LOAD_OFFER_PARTNER_ELIGIBILITY_SUCCESS: {
      const partnerId = action.payload.partnerId;
      const eligibility = {
        ...state.partnerEligibility,
        [partnerId]: {
          partnerId,
          isLoaded: true
        }
      };

      return {
        ...state,
        partnerEligibility: eligibility
      };
    }
    case eventTypes.OFFER_PARTNER_ELIGIBILITY_UPDATED:
      return initialState.currentOffer.partnerEligibilityData;

    case eventTypes.OFFER_PARTNER_ELIGIBILITY_INVALIDATED:
      return initialState.currentOffer.partnerEligibilityData;

    default:
      return state;
  }
}
